/* eslint-disable */

import axios from 'axios'

const clearState = (context) => {
  context.commit('clearRewardsState');
}

const setRewardBeingEdited = (context, reward) => {
  context.commit('updateRewardBeingEdited', reward);
}

const parseAdvertiser = (context, data) => {
  for (var i = 0; i < data.rewards.length; i++) {
    const date_modified = new Date(data.rewards[i].date_modified);
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    var last_edited = date_modified.toLocaleDateString("en-US", options);
    last_edited = last_edited.charAt(0) + last_edited.slice(1).toLowerCase();
    
    const payload = {
      advertiser_id: context.getters.advertiser.id,
      reward: {
        id: data.rewards[i].id,
        live: data.rewards[i].in_use,
        is_archived: data.rewards[i].is_archived,
        title: data.rewards[i].title,
        point_value: data.rewards[i].point_cost,
        last_edited: last_edited,
      },
    }

    context.commit('addReward', payload);
  }
}

const updateRewardLiveStatus = (context, payload) => {
  context.commit('updateRewardLiveStatus', payload);
}

const uploadRewardLiveStatusUpdate = async (context, payload) => {
  const headers = {
    headers: {
      Authorization: `JWT ${context.rootState.jwt.jwt}`
    }
  }

  await axios.put(context.state.endpoints.updateRewardLiveStatus, payload, headers)
    .then((response)=>{
        context.dispatch('updateRewardLiveStatus', payload);
      })
    .catch((error)=>{
      console.log(error);
    })
}

const updateRewardArchivedStatus = (context, payload) => {
  context.commit('updateRewardArchivedStatus', payload);
}

const uploadRewardArchivedStatus = async (context, payload) => {
  const headers = {
    headers: {
      Authorization: `JWT ${context.rootState.jwt.jwt}`
    }
  }

  await axios.put(context.state.endpoints.updateRewardArchivedStatus, payload, headers)
    .then((response)=>{
        context.dispatch('updateRewardArchivedStatus', payload);
      })
    .catch((error)=>{
      console.log(error);
    })
}

const obtainReward = async (context, id) => {
  await context.dispatch('inspectToken');

  if (context.getters.isLoggedIn) {
    const payload = {
      headers: {
        Authorization: `JWT ${context.rootState.jwt.jwt}`
      },
      params: {
        reward_id: id,
        merchant_id: context.rootState.advertiser.advertiser.id,
      }
    }
    
    await axios.get(context.state.endpoints.rewardDetail, payload)
      .then((response)=>{
        var parsed_payload = response.data
        parsed_payload.advertiser_id = payload.params.merchant_id
        context.commit('updateRewardDetails', parsed_payload);
      })
      .catch((error)=>{
        console.log(error);
      })
  }
}

const updateReward = (context, payload) => {
  context.commit('updateReward', payload);
}

const uploadRewardUpdates = async (context, payload) => {
  const headers = {
    headers: {
      Authorization: `JWT ${context.rootState.jwt.jwt}`,
      'Content-Type': 'application/json',
    }
  }

  await axios.put(context.state.endpoints.updateReward, JSON.stringify(payload.upload_payload), headers)
    .then((response)=>{
        context.dispatch('updateReward', payload.reward_payload);
      })
    .catch((error)=>{
      console.log(error);
    })
}

const addReward = (context, payload) => {
  context.commit('addReward', payload);
}

const uploadNewReward = async (context, payload) => {
  const headers = {
    headers: {
      Authorization: `JWT ${context.rootState.jwt.jwt}`,
      'Content-Type': 'application/json',
    }
  }

  await axios.post(context.state.endpoints.addReward, JSON.stringify(payload.upload_payload), headers)
    .then((response)=>{
        console.log(response)
        payload.reward_payload.reward.id = response.data.id;
        context.dispatch('addReward', payload.reward_payload);
      })
    .catch((error)=>{
      console.log(error);
    })
}

export default {
  clearState,
  setRewardBeingEdited,
  parseAdvertiser,
  updateRewardLiveStatus,
  uploadRewardLiveStatusUpdate,
  updateRewardArchivedStatus,
  uploadRewardArchivedStatus,
  obtainReward,
  updateReward,
  addReward,
  uploadRewardUpdates,
  uploadNewReward,
}